import React, { useState, useEffect } from 'react';
import Styles from './SeguroAuto25Facilidades.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';
function SeguroAuto25Facilidades() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  const [showModalContatoSantander, setShowModalContatoSantander] = useState(false);
  const [showModalContatoZurich, setShowModalContatoZurich] = useState(false);

  useEffect(() => {
    if (showModalContatoSantander) {
      document.getElementsByTagName('html')[0].classList.add('scroll-disabled');
    } else {
      document.getElementsByTagName('html')[0].classList.remove('scroll-disabled');
    }
  }, [showModalContatoSantander]);

  useEffect(() => {
    if (showModalContatoZurich) {
      document.getElementsByTagName('html')[0].classList.add('scroll-disabled');
    } else {
      document.getElementsByTagName('html')[0].classList.remove('scroll-disabled');
    }
  }, [showModalContatoZurich]);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="seguro-auto-facilidades">
        <ContainerHome24>
          <div className="facilidades-contain-1">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 992 && (
                  <h2 className="facilidades-titulo">
                    Com a Santander Auto você contrata o seu seguro com diversas facilidades:
                  </h2>
                )}
                {width > 992 && (
                  <h2 className="facilidades-titulo">
                    Com o Santander você contrata o seu seguro com diversas facilidades
                  </h2>
                )}
              </>
            )}
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 992 && (
                  <div className="carrossel-facilidades-1">
                    <CustomEmblaCarouselHome24 enableBullets enableMobileArrows detectBulletCount>
                      {({ className }) => (
                        <>
                          <div className={`slide ${className} slide-menor`}>
                            <img
                              src="assets/seguro-auto-25/facilidades/ic_bank_credit.svg"
                              alt=""
                            />
                            <p className="carrossel-facilidades-1-texto">
                              Contratação junto ou à <br />
                              parte do financiamento <br />
                              do seu veículo*
                            </p>
                          </div>
                          <div className={`slide ${className}`}>
                            <img src="assets/seguro-auto-25/facilidades/ic_std_people.svg" alt="" />
                            <p className="carrossel-facilidades-1-texto">
                              Oferecemos seguro para PF e PJ:
                              <br />
                              • Carros novos e usados
                              <br />• Motorista de aplicativo e táxi
                              <br />• Motos de alta e baixa cilindrada
                            </p>
                          </div>
                          <div className={`slide ${className}`}>
                            <img
                              src="assets/seguro-auto-25/facilidades/ic_civil_liability.svg"
                              alt=""
                            />
                            <p className="carrossel-facilidades-1-texto">
                              Inclua o valor de seu seguro <br />
                              no financiamento de <br />
                              seu veículo.
                            </p>
                          </div>
                          <div className={`slide ${className}`}>
                            <img
                              src="assets/seguro-auto-25/facilidades/ic_internet_banking.svg"
                              alt=""
                            />
                            <p className="carrossel-facilidades-1-texto">
                              Acompanhe através <br />
                              das plataformas digitais
                            </p>
                          </div>
                        </>
                      )}
                    </CustomEmblaCarouselHome24>
                  </div>
                )}
                {width > 992 && (
                  <div className="cards-facilidades">
                    <div className="card-facilidades">
                      <img src="assets/seguro-auto-25/facilidades/ic_bank_credit.svg" alt="" />
                      <p className="carrossel-facilidades-1-texto">
                        Contratação junto ou à <br />
                        parte do financiamento do <br />
                        seu veículo*
                      </p>
                    </div>
                    <div className="card-facilidades">
                      <img src="assets/seguro-auto-25/facilidades/ic_std_people.svg" alt="" />
                      <p className="carrossel-facilidades-1-texto">
                        Oferecemos seguro para PF e PJ:
                        <br />
                        • Carros novos e usados
                        <br />• Motorista de aplicativo e táxi
                        <br />• Motos de alta e baixa cilindrada
                      </p>
                    </div>
                    <div className="card-facilidades">
                      <img src="assets/seguro-auto-25/facilidades/ic_civil_liability.svg" alt="" />
                      <p className="carrossel-facilidades-1-texto">
                        Inclua o valor de seu seguro <br />
                        no financiamento de <br />
                        seu veículo.
                      </p>
                    </div>
                    <div className="card-facilidades">
                      <img src="assets/seguro-auto-25/facilidades/ic_internet_banking.svg" alt="" />
                      <p className="carrossel-facilidades-1-texto">
                        Acompanhe através <br />
                        das plataformas digitais
                      </p>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div className="facilidades-contain-2">
            <div className="carrossel-facilidades-2">
              <CustomEmblaCarouselHome24 enableBullets enableMobileArrows detectBulletCount>
                {({ className }) => (
                  <>
                    <div className={`slide ${className}`}>
                      <img
                        src="assets/seguro-auto-25/facilidades/logo-santander-auto.svg"
                        alt=""
                        className="logo-santander-auto"
                      />
                      <p className="carrossel-facilidades-2-texto">
                        Com a Santander Auto, você tem um dia a dia mais tranquilo, confortável e
                        seguro para você e seu veículo. <br />
                        <br />
                        Confira os canais de atendimento abaixo para <b>seguros do Santader</b>.
                      </p>
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          setShowModalContatoSantander(true);
                        }}
                        className="carrossel-facilidades-2-link"
                      >
                        Canais de atendimento
                      </div>
                    </div>
                    <div className={`slide ${className}`}>
                      <img src="assets/seguro-auto-25/facilidades/logo-zurich.svg" alt="" />
                      <p className="carrossel-facilidades-2-texto">
                        Ao financiar seu veículo com a gente, seu Seguro Auto pode ser Zurich.{' '}
                        <br />
                        <br />
                        Se precisar, acesse os canais de atendimento abaixo e conte com todas as
                        vantagens de ser Zurich.
                      </p>
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          setShowModalContatoZurich(true);
                        }}
                        className="carrossel-facilidades-2-link"
                      >
                        Canais de atendimento
                      </div>
                    </div>
                  </>
                )}
              </CustomEmblaCarouselHome24>
            </div>
          </div>
        </ContainerHome24>
      </section>
      {showModalContatoSantander && (
        <section id="modal-canais-contato-santander" className="modal-canais-contato">
          <div className="modal">
            <div
              onClick={() => {
                setShowModalContatoSantander(false);
              }}
              className="close-modal"
            >
              <img src="assets/shared/close-modal-seguros.svg" alt="" />
            </div>
            <div className="modal-canais-contato-titulo">
              <img src="assets/shared/ic_phone.svg" alt="" />
              <p className="modal-seguros-titulo">Canais de contato</p>
            </div>

            <div className="modal-canais-contato-contatos">
              <div className="bloco-contato">
                <div className="bloco-contato-titulo">Assistência 24 horas</div>
                <div className="bloco-contato-texto">
                  <p>Funcionamento 24 horas por dia, 7 dias por semana.</p>
                  <p className="bloco-contato-telefones">
                    <div>
                      <a href="tel:(11) 99931 6239" className="contato-link-tel">
                        (11) 99931 6239
                      </a>{' '}
                      (
                      <a
                        href="https://api.whatsapp.com/send?phone=5511999316239"
                        target="_blank"
                        className="contato-link"
                      >
                        Iniciar
                      </a>{' '}
                      conversa pelo WhatsApp)
                    </div>
                    <div>
                      <a href="tel:0800 201 9500" className="contato-link-tel">
                        0800 201 9500
                      </a>
                    </div>
                    <div>
                      <a href="tel:0800 201 9002" className="contato-link-tel">
                        0800 201 9002
                      </a>{' '}
                      (pessoas com deficiência auditiva)
                    </div>
                  </p>
                </div>
              </div>
              <div className="bloco-contato">
                <div className="bloco-contato-titulo">Sinistro</div>
                <div className="bloco-contato-texto">
                  <p>Segunda a sexta-feira, das 8h às 19h, exceto feriados.</p>
                  <p className="bloco-contato-telefones">
                    <div>
                      <a href="tel:(11) 99931 6239" className="contato-link-tel">
                        (11) 99931 6239
                      </a>{' '}
                      (
                      <a
                        href="https://api.whatsapp.com/send?phone=5511999316239"
                        target="_blank"
                        className="contato-link"
                      >
                        Iniciar
                      </a>{' '}
                      conversa pelo WhatsApp)
                    </div>
                    <div>
                      <a href="tel:0800 201 9500" className="contato-link-tel">
                        0800 201 9500
                      </a>
                    </div>
                    <div>
                      <a href="tel:0800 201 9002" className="contato-link-tel">
                        0800 201 9002
                      </a>{' '}
                      (pessoas com deficiência auditiva)
                    </div>
                  </p>
                </div>
              </div>
              <div className="bloco-contato">
                <div className="bloco-contato-titulo">Carro Reserva</div>
                <div className="bloco-contato-texto">
                  <p>Segunda a sexta-feira, das 8h às 20h e aos sábados das 8h às 14h.</p>
                  <p className="bloco-contato-telefones">
                    <div>
                      <a href="tel:(31) 97139 1451" className="contato-link-tel">
                        (31) 97139 1451
                      </a>{' '}
                      (
                      <a
                        href="https://api.whatsapp.com/send?phone=5531971391451"
                        target="_blank"
                        className="contato-link"
                      >
                        Iniciar
                      </a>{' '}
                      conversa pelo WhatsApp)
                    </div>
                  </p>
                </div>
              </div>
              <div className="bloco-contato">
                <div className="bloco-contato-titulo">Vidros</div>
                <div className="bloco-contato-texto">
                  <p>Segunda a sexta-feira, das 8h às 20h e aos sábados das 8h às 14h.</p>
                  <p className="bloco-contato-telefones">
                    <div>
                      <a href="tel:(27) 3320 4114" className="contato-link-tel">
                        (27) 3320 4114
                      </a>{' '}
                      (
                      <a
                        href="https://api.whatsapp.com/send?phone=552733204114"
                        target="_blank"
                        className="contato-link"
                      >
                        Iniciar
                      </a>{' '}
                      conversa pelo WhatsApp)
                    </div>
                  </p>
                </div>
              </div>
              <div className="bloco-contato">
                <div className="bloco-contato-titulo">
                  Assuntos gerais relacionados ao seguro (apólice, pagamento, alteração, renovação)
                </div>
                <div className="bloco-contato-texto">
                  <p>Segunda a sexta-feira, das 8h às 19h, exceto feriados.</p>
                  <p className="bloco-contato-telefones">
                    <div>
                      <a href="tel:(11) 99931 6239" className="contato-link-tel">
                        (11) 99931 6239
                      </a>{' '}
                      (
                      <a
                        href="https://api.whatsapp.com/send?phone=5511999316239"
                        target="_blank"
                        className="contato-link"
                      >
                        Iniciar
                      </a>{' '}
                      conversa pelo WhatsApp)
                    </div>
                    <div>
                      <a href="tel:0800 201 9500" className="contato-link-tel">
                        0800 201 9500
                      </a>
                    </div>
                    <div>
                      <a href="tel:0800 201 9002" className="contato-link-tel">
                        0800 201 9002
                      </a>{' '}
                      (pessoas com deficiência auditiva)
                    </div>
                  </p>
                </div>
              </div>
              <div className="bloco-contato">
                <div className="bloco-contato-titulo">SAC</div>
                <div className="bloco-contato-texto">
                  <p>Funcionamento 24 horas por dia, 7 dias por semana.</p>
                  <p className="bloco-contato-telefones">
                    <div>
                      <a href="tel:0800 201 9500" className="contato-link-tel">
                        0800 201 9500
                      </a>{' '}
                      (Exclusivo para cancelamentos e reclamações)
                    </div>
                    <div>
                      <a href="tel:0800 202 1333" className="contato-link-tel">
                        0800 202 1333
                      </a>{' '}
                      (pessoas com deficiência auditiva)
                    </div>
                  </p>
                </div>
              </div>
              <div className="bloco-contato">
                <div className="bloco-contato-titulo">
                  Segurado no Mercosul e precisa acionar assistência ou sinistro
                </div>
                <div className="bloco-contato-texto">
                  <p>Funcionamento 24 horas por dia, 7 dias por semana.</p>
                  <p className="bloco-contato-telefones">
                    <div>
                      <a href="tel:+55 (11) 3206 1507" className="contato-link-tel">
                        +55 (11) 3206 1507
                      </a>
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {showModalContatoZurich && (
        <section id="modal-canais-contato-zurich" className="modal-canais-contato">
          <div className="modal">
            <div
              onClick={() => {
                setShowModalContatoZurich(false);
              }}
              className="close-modal"
            >
              <img src="assets/shared/close-modal-seguros.svg" alt="" />
            </div>
            <div className="modal-canais-contato-titulo">
              <img src="assets/shared/ic_phone.svg" alt="" />
              <p className="modal-seguros-titulo">Canais de contato</p>
            </div>

            <div className="modal-canais-contato-contatos">
              <div className="bloco-contato">
                <div className="bloco-contato-titulo">Telefones</div>
                <div className="bloco-contato-texto">
                  <p>
                    Acionar seguro, acompanhamento do processo de acionamento do seguro e
                    informações da apólice/certificado.
                    <br />
                    <br />
                    Horário de atendimento: segunda a sexta-feira 8h às 20h / aos sábados 8h às 18h,
                    exceto feriados nacionais
                  </p>
                  <p className="bloco-contato-telefones">
                    <div>
                      <a href="tel:4020 4848" className="contato-link-tel">
                        4020 4848
                      </a>{' '}
                      (Capital e regiões metropolitanas)
                    </div>
                    <div>
                      <a href="tel:0800 285 4141" className="contato-link-tel">
                        0800 285 4141
                      </a>{' '}
                      (Demais localidades)
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      <style jsx>{Styles}</style>
    </>
  );
}

export default SeguroAuto25Facilidades;
